import { Stack, Typography } from "@mui/material";

export const ToggleLabel = ({
  label,
  caption,
}: {
  label: string;
  caption: string;
}) => (
  <Stack>
    <Typography variant="body2">{label}</Typography>
    <Typography variant="caption">{caption}</Typography>
  </Stack>
);
